var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 12.9998V12.1998C10.6666 11.0797 10.6666 10.5197 10.4487 10.0919C10.2569 9.71553 9.95095 9.40957 9.57463 9.21782C9.1468 8.99984 8.58675 8.99984 7.46665 8.99984H4.53331C3.41321 8.99984 2.85316 8.99984 2.42533 9.21782C2.04901 9.40957 1.74305 9.71553 1.5513 10.0919C1.33331 10.5197 1.33331 11.0797 1.33331 12.1998V12.9998M10.6666 2.99984L12 4.33317L14.6666 1.6665M8.33331 3.99984C8.33331 5.2885 7.28864 6.33317 5.99998 6.33317C4.71131 6.33317 3.66665 5.2885 3.66665 3.99984C3.66665 2.71117 4.71131 1.6665 5.99998 1.6665C7.28864 1.6665 8.33331 2.71117 8.33331 3.99984Z",
    stroke: "#25324B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/UserCheck.e35a0af72d1bb6d099ff2c290c261ee3.svg";
export { ForwardRef as ReactComponent };